module.exports = __webpack_public_path__ + "img/mail-inactive.c29eb7e2.svg";